








import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseVue from "@/core/BaseVue";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import MapComponent from "@/components/map/map.vue";
import Direccion from '@/models/direccion.model';

@Component({
  components: { MapComponent }
})
export default class DireccionMapa extends BaseVue {
  @Prop() public whereParams!: string;
  @Prop() public value!: number | any;

  loading = false;
  initModel = new Direccion();
  direccion = this.map<Direccion>(this.initModel);
  client = new BaseRepository<Direccion>("direccion");
 location: any = String();
get query() {
    var pais = "Republica dominicana";
    if (this.direccion.calleStr)
      return `${pais}, ${this.direccion.provinciaNombre} ${this.direccion.barrioNombre} calle ${this.direccion.calleStr}`;

    if (this.direccion.barrioNombre)
      return `${pais}, ${this.direccion.provinciaNombre} ${this.direccion.barrioNombre}`;

    if (this.direccion.provinciaNombre) return `${pais}, ${this.direccion.provinciaNombre}`;

    return `${pais}`;
  }
  get isId() {
    return !isNaN(this.value);
  }

  async getDataAsync() {
    try {
      this.loading = true;
      if (this.value && this.isId) {
        let where = String();
        let include =
          "Region|Provincia|Municipio|DistritoMunicipal|Seccion|Barrio";
        if (this.whereParams) where += `id=${this.value}`;
        else where = `id=${this.value}`;

        this.direccion = await this.client.one(where, include);
      } else {
        this.direccion = this.value;
      }
      this.$emit("change", this.direccion);
    } catch (e) {
      this.direccion = this.map<Direccion>(this.initModel);
      this.$emit("change", null);
      this.operationFailedErrors(e);
    } finally {
      this.loading = false;
    }
  }

  @Watch("value", { deep: true, immediate: true })
  OnValueChange(value: any) {
    if (!value) {
      this.direccion = this.map<Direccion>(this.initModel);
      this.$emit("change", null);
      return;
    }
    this.getDataAsync();
  }

  close() {
    this.direccion = this.map<Direccion>(this.initModel);
    this.$emit("close", null);
    this.$emit("change", null);
  }
}
